"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
export default function useIsMobileDevice() {
  const $ = _c(2);
  const [isMobile, setIsMobile] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const userAgent = typeof navigator === "undefined" ? "" : navigator.userAgent;
      const regex = /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i;
      const mobile = regex.exec(userAgent) !== null;
      setIsMobile(mobile);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return isMobile;
}